import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth'; // 🟢 CORRECCIÓN: Importamos el hook refactorizado
import { getMediaUrl } from '../../utils/imageUtils';
const avatarFallback = '/images/avatar/DefaultProfile.jpg';

const formatTimeAgo = (date) => {
  if (!date) return '';
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) return `${Math.floor(interval)}a`;
  interval = seconds / 2592000;
  if (interval > 1) return `${Math.floor(interval)}m`;
  interval = seconds / 86400;
  if (interval > 1) return `${Math.floor(interval)}d`;
  interval = seconds / 3600;
  if (interval > 1) return `${Math.floor(interval)}h`;
  interval = seconds / 60;
  if (interval > 1) return `${Math.floor(interval)}min`;
  return 'ahora';
};

const ReplyInput = ({ onSubmit }) => {
  const [text, setText] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onSubmit(text);
      setText('');
    }
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center space-x-2 mt-2 pl-10"
    >
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Escribe una respuesta..."
        className="flex-1 text-xs p-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-full"
      />
      <button
        type="submit"
        className="text-xs font-semibold text-blue-600 hover:underline"
      >
        Publicar
      </button>
    </form>
  );
};

const CommentItem = ({
  comment,
  onLike,
  onReply,
  isReplying,
  setReplyingTo,
}) => {
  const { currentUser } = useAuth();
  // 🟢 SOLUCIÓN: Nos aseguramos de que 'likes' sea siempre un array para evitar el error.
  const isLiked = (comment.likes || []).includes(currentUser?._id);
  const authorIsSenator = comment.author?.rank === 'senator' || comment.author?.tier === 'senador';

  return (
    <div className="flex flex-col">
      <div className="flex items-start space-x-3">
        <img
          src={comment.author?.avatar ? getMediaUrl(comment.author.avatar) : avatarFallback}
          alt={comment.author?.username}
          className={`w-8 h-8 rounded-full object-cover ${authorIsSenator ? 'gold-aura' : ''}`}
        />
        <div className="flex-1">
          <div className="bg-gray-100 dark:bg-gray-700 p-2 rounded-lg">
            <h4 className="font-semibold text-sm text-gray-800 dark:text-gray-100">
              {comment.author?.username}
            </h4>
            <p className="text-sm text-gray-800 dark:text-gray-100">{comment.text}</p>
          </div>
          <div className="flex items-center space-x-3 text-xs text-gray-500 dark:text-gray-400 mt-1 pl-2">
            <span>{formatTimeAgo(comment.createdAt)}</span>
            <button
              onClick={() => onLike(comment._id)}
              className={`font-semibold ${isLiked ? 'text-blue-600' : 'hover:underline'}`}
            >
              Me gusta
            </button>
            <button
              onClick={() => setReplyingTo(comment._id)}
              className="font-semibold hover:underline"
            >
              Responder
            </button>
            {comment.likes?.length > 0 && (
              <span className="flex items-center">
                <i className="fas fa-thumbs-up text-blue-500 text-xs mr-1"></i>
                {comment.likes?.length}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Respuestas */}
      {comment.replies && comment.replies.length > 0 && (
        <div className="pl-10 mt-2 space-y-2">
          {comment.replies.map((reply) => (
            <CommentItem
              key={reply._id}
              comment={reply}
              onLike={() => {}}
              onReply={() => {}}
            />
          ))}
        </div>
      )}

      {/* Input para responder */}
      {isReplying && (
        <ReplyInput onSubmit={(text) => onReply(comment._id, text)} />
      )}
    </div>
  );
};

export default CommentItem;
